import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../constants";
const ProductCapabilities = () => {
  const cardData = [
    {
      img: "decision_making/strategic_ alignment.png",
      title: "Strategic Alignment",
      text: "Ensure energy projects align with business goals, regulatory requirements, and sustainability targets...",
    },
    {
      img: "decision_making/resource_ optimization.png",
      title: "Resource Optimization",

      text: "Maximize efficiency by optimizing capital, infrastructure, and operational resources for better outcomes.",
    },
    {
      img: "decision_making/stakeholder_ alignment.png",
      title: "Stakeholder Alignment",
      text: "Facilitate collaboration by integrating insights that align decision-making across teams and partners.",
    },
    {
      img: "decision_making/risk_management.png",
      title: "Risk Management",
      text: "Identify, assess, and mitigate financial, operational, and environmental risks with AI-powered analysis.",
    },
  ];

  return (
    <Container fluid>
      <div
        className="product-capabilities-container"
        style={{
          backgroundImage: `url(${BASE_URL}decision_making/decision_making_bg.png)`,
        }}
      >
        <Container>
          <div>
            <h1 className="product-capabilities-heading  mb-3">
              Navigating
              <br />
              <span>
                Complexities  <br />
                In Decision Making
                <img
                  src={`${BASE_URL}common-images/mask_image.png`}
                  alt="mask"
                  className="masking"
                />
              </span>
            </h1>
          </div>
          <Row>
            {cardData.map((card, index) => (
              <Col key={index} xs={12} md={6} lg={6} className="mb-4">
                <Card className="w-100 h-100 product-capabilities-card">
                  <Card.Body>
                    <Row>
                      <Col xs={12} sm={6}>
                        <Card.Img
                          variant="top"
                          src={`${BASE_URL}${card.img}`} // Construct full URL
                          width={100}
                          height={300}
                        />
                      </Col>
                      <Col xs={12} sm={6} className="d-flex flex-column">
                        <Card.Title className="card-title">
                          {card.title}
                        </Card.Title>
                        <Card.Text className="card-text">{card.text}</Card.Text>

                        <div className="button-container">
                          <Link to="/features">
                            {/* <Button className="custom-buttonLearn">
                          Learn More
                        </Button> */}
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </Container>
  );
};

export default ProductCapabilities;
